import { render, staticRenderFns } from "./CreateAd.vue?vue&type=template&id=8c560d06&scoped=true"
import script from "./CreateAd.vue?vue&type=script&lang=js"
export * from "./CreateAd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c560d06",
  null
  
)

export default component.exports